import './text-element.scss';

export default {
  label: 'label-override',
  countdownValid: 'countdown-valid',
  countdownInvalid: 'countdown-invalid',
  group: 'form-group',
  textarea: 'form-control text-input',
  readOnlyText: 'form-control text-input readonly-textarea',
  inputWrapper: '',
  requiredIndicator: 'required-indicator',
}
